;(function() {
  'use strict'

  angular.module('app.core').component('gTag', {
    controller: Controller,
    templateUrl: 'g-tag.html',
    bindings: {
      label: '<',
      remove: '&?',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()
